import {Component, Input, OnInit} from '@angular/core';
import {DataARClaimAttachmentModel} from '../../../../models/accountsReceivable/data-ar-claim-attachments.model';
import {
  DentalxchangeValidationResponseModel, DXCClaimItemResponse,
  DXCClaimStatus
} from '../../../../models/accountsReceivable/dentalxchange-validation-response.model';

@Component({
  selector: 'app-claim-validation-detail-dxc-parsed',
  templateUrl: './claim-validation-detail-dxc-parsed.component.html',
  styleUrls: ['./claim-validation-detail-dxc-parsed.component.scss']
})
export class ClaimValidationDetailDxcParsedComponent  implements OnInit {

  @Input() resp: string;

  respObj: DentalxchangeValidationResponseModel;

  ngOnInit() {
    this.parseResp();
  }

  parseResp() {
    const respParsed: unknown = JSON.parse(this.resp);
    this.respObj = respParsed as DentalxchangeValidationResponseModel;
  }

  returnCodeFromControlNumber(cn: string) {
    if (cn) {
      const cnSplit = cn.split('_', 3);
      return cnSplit[2];
    }
    else {
      return '';
    }
  }
}
